/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Assignments styles
 *
 * @file assignmentsStyles.js
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import { styled } from '@mui/material/styles';
import { createScopedStyles } from '../../../assets/styles/createScopedStyles';
import assignmentsLayoutStyles, { classes as assignmentsLayoutClasses } from './assignmentsLayoutStyles';
import assignmentFormStyles, { classes as assignmentFormClasses } from './assignmentFormStyles';
import assignmentListStyles, { classes as assignmentListClasses } from './assignmentListStyles';
import assignmentListItemStyles, { classes as assignmentListItemClasses } from './assignmentListItemStyles';
import chapterContentTreeStyles, {
  classes as chapterContentTreeClasses
} from '../../chapter-content/styles/chapterContentTreeStyles';

const assignmentsStyles = () => ({
  ...assignmentsLayoutStyles,
  ...assignmentFormStyles,
  ...assignmentListStyles,
  ...assignmentListItemStyles,
  ...chapterContentTreeStyles
});

/**
 * Slot class names of every rule map aggregated here. The class names come from
 * the individual modules so that a slot resolves to the same class whether it is
 * reached through this aggregate or through the module that declares it.
 */
export const classes = {
  ...assignmentsLayoutClasses,
  ...assignmentFormClasses,
  ...assignmentListClasses,
  ...assignmentListItemClasses,
  ...chapterContentTreeClasses
};

export const scopedStyles = createScopedStyles(assignmentsStyles(), classes);

export const AssignmentsStylesRoot = styled('div')(scopedStyles);

export default assignmentsStyles;
